export default "__VITE_ASSET__CYkPVUTE__"